var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 144,
    viewBox: "0 0 145 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_512_1961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.384 93.4519L132.144 89.5747C132.106 89.3698 132.069 89.1574 132.015 88.9525C131.689 87.5336 131.037 86.35 130.308 85.3636C132.198 82.5714 133.222 79.2784 133.222 75.8943C133.222 66.5541 125.619 58.9513 116.279 58.9513C113.517 58.9513 110.823 59.619 108.403 60.8937C107.887 60.3702 107.363 59.8467 106.84 59.3231L99.6849 50.772C100.421 48.8447 100.8 46.834 100.8 44.7702C100.8 35.4299 93.1975 27.8272 83.8572 27.8272C83.2654 27.8272 82.666 27.8651 82.0438 27.9334C81.8086 27.7134 81.5734 27.4933 81.3382 27.2809L75.5261 21.8785L75.1012 21.3702C75.6323 19.7768 75.9131 18.0999 75.9131 16.4459C75.9131 10.9145 72.5745 5.72465 67.7868 3.83535C61.5574 1.37699 54.7438 4.70792 50.7603 9.10112C48.6586 11.4153 47.2473 14.033 45.8891 16.5673C44.5689 19.018 43.3245 21.3398 41.5718 23.0926C39.8646 24.8073 37.4138 25.6192 34.5609 26.5752C32.186 27.3643 29.7201 28.1838 27.4362 29.6558C24.2039 31.7348 21.7076 34.876 20.4025 38.4953C19.75 40.3163 19.4389 42.1145 19.1354 43.8597C18.7864 45.8628 18.4905 47.5928 17.7545 49.042C16.7074 51.1058 14.6057 52.7447 12.6936 54.0649C9.98483 55.9391 7.71616 58.0939 5.75098 60.6509C0.54592 67.4266 -0.432875 74.6651 3.06499 80.5151C5.27296 84.2027 9.35507 86.7445 13.7179 87.1543C17.7014 87.526 21.7152 86.183 24.7502 83.5729L48.5524 88.7249C50.4568 92.2531 53.5146 94.9542 57.2173 96.4186C56.7621 99.4461 56.4434 102.481 57.2932 105.015C58.1582 107.603 60.1689 109.636 62.7942 110.607C65.3815 111.556 68.1662 111.328 70.4424 109.962C73.0222 108.415 74.995 105.372 77.0891 102.147C78.3031 100.266 80.8374 96.358 81.9603 96.1076C82.2638 96.0772 82.6129 96.1076 83.0909 96.54C84.487 97.7541 85.3216 100.554 85.4278 102.678C85.5568 105.281 85.3216 107.929 85.0561 110.524C81.7934 112.997 80.0786 117.049 80.5718 121.131C80.716 122.307 81.4747 123.339 82.5522 123.832C83.2123 124.136 83.8952 124.371 84.6084 124.538C84.6387 124.766 84.6691 124.986 84.6994 125.198C85.0181 127.353 85.6555 130.54 87.4461 133.362C89.3961 136.428 92.4691 138.507 95.6786 138.917C96.1035 138.97 96.5284 139 96.9533 139C102.295 139 106.514 134.668 107.91 130.396C109.162 126.587 108.911 122.209 107.151 117.011C106.787 115.926 106.263 114.629 105.656 113.126C104.207 109.515 102.151 104.401 101.635 100.228L127.85 105.903C128.404 106.024 128.958 106.085 129.512 106.085C132.198 106.085 134.648 104.697 136.052 102.367C137.774 99.5144 137.509 96.0165 135.369 93.4595L135.384 93.4519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3887 15.1863C63.4538 17.1211 9.98438 76.7896 9.98438 76.7896L128.593 102.481C132.501 103.331 135.27 98.748 132.705 95.6826L65.3887 15.1787V15.1863Z",
    fill: "#A94EFF",
    stroke: "#1D074F",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3575 76.987C38.9464 78.2693 43.1802 78.1555 46.9816 77.9583C50.783 77.761 58.2946 75.7958 61.1248 78.3452C65.002 81.8355 61.2765 87.4199 61.3221 90.9406C61.36 94.4536 59.4252 100.592 60.5481 103.923C61.6711 107.254 65.776 108.764 68.682 107.026C73.0448 104.408 76.9145 93.103 81.6643 92.6933C86.2168 92.2987 88.6448 98.1487 88.8573 102.504C89.2215 109.917 86.9604 117.125 88.091 124.69C88.4476 127.08 89.047 129.485 90.3445 131.526C91.6419 133.567 93.7209 135.214 96.1186 135.517C99.9048 136.003 103.471 132.953 104.662 129.326C105.853 125.699 105.14 121.723 103.919 118.112C101.878 112.079 93.5312 96.138 101.43 91.3427C105.58 88.8236 122.554 98.5509 126.355 95.5386C128.662 93.71 129.329 92.5947 128.677 89.7266C128.024 86.8585 124.815 84.8553 123.047 82.5032C115.042 71.9034 105.368 62.6997 95.9365 53.3442C94.1534 51.5839 92.3703 49.7933 91.0046 47.6915C88.8876 44.444 87.8633 40.5971 85.8147 37.3117C84.024 34.4361 81.505 32.0991 79.0238 29.7925C76.3227 27.2886 73.6215 24.7771 70.9203 22.2732C70.1009 21.5069 69.2435 20.7253 68.1736 20.3839C67.0355 20.0197 65.7911 20.1942 64.6378 20.5129C59.6832 21.8635 55.7301 25.5207 52.1563 29.2082C45.2896 36.2874 15.4326 69.8851 35.3726 77.0098L35.3575 76.987Z",
    fill: "url(#paint0_linear_512_1961)",
    stroke: "#1D074F",
    strokeWidth: 3.03,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4916 16.4383C72.4916 12.4928 70.2002 8.4638 66.5278 7.01458C61.9297 5.20115 56.6184 7.7278 53.2951 11.3926C49.4861 15.5961 48.0217 21.4613 44.0003 25.4979C40.0548 29.4586 33.8634 29.5875 29.2881 32.5239C26.6931 34.1932 24.6748 36.735 23.6278 39.6335C22.3531 43.192 22.52 47.2058 20.8052 50.5747C19.447 53.2531 17.0645 55.188 14.6365 56.8648C12.2692 58.5037 10.2281 60.4234 8.46025 62.7224C4.9548 67.2901 2.80752 73.4056 6.00188 78.7397C7.68632 81.5471 10.782 83.4212 14.0371 83.7247C17.2922 84.0282 20.6383 82.7915 22.998 80.5228C26.5034 77.1539 27.5961 72.2068 29.7433 68.0109C32.0272 63.5418 35.6009 61.0986 40.2445 59.3838C44.061 57.965 48.1356 56.88 51.2768 54.2774C54.2359 51.8267 56.057 48.2605 57.4151 44.664C58.7657 41.0599 59.7369 37.3117 61.4138 33.8442C63.1134 30.3311 65.4352 27.979 68.364 25.513C70.9817 23.3051 72.4916 19.8451 72.4992 16.4307L72.4916 16.4383Z",
    fill: "url(#paint1_linear_512_1961)",
    stroke: "#1D074F",
    strokeWidth: 3.03,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8577 58.1925C91.2749 58.1925 97.2877 52.1797 97.2877 44.7625C97.2877 37.3453 91.2749 31.3325 83.8577 31.3325C76.4405 31.3325 70.4277 37.3453 70.4277 44.7625C70.4277 52.1797 76.4405 58.1925 83.8577 58.1925Z",
    fill: "url(#paint2_linear_512_1961)",
    stroke: "#1D074F",
    strokeWidth: 3.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4808 46.8433C93.6436 42.0803 90.7251 37.2765 85.9621 36.1136C81.1992 34.9508 76.3953 37.8692 75.2325 42.6322C74.0696 47.3952 76.9881 52.199 81.7511 53.3619C86.5141 54.5247 91.3179 51.6062 92.4808 46.8433Z",
    fill: "url(#paint3_linear_512_1961)",
    stroke: "#1D074F",
    strokeWidth: 3.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.374 88.3001C128.239 85.4916 131.527 77.6498 128.719 70.7849C125.91 63.92 118.068 60.6317 111.203 63.4402C104.339 66.2487 101.05 74.0905 103.859 80.9554C106.667 87.8202 114.509 91.1086 121.374 88.3001Z",
    fill: "url(#paint4_linear_512_1961)",
    stroke: "#1D074F",
    strokeWidth: 3.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.918 77.9436C126.039 73.1706 123.079 68.3925 118.306 67.2712C113.533 66.15 108.755 69.1103 107.634 73.8832C106.512 78.6562 109.473 83.4343 114.246 84.5556C119.019 85.6768 123.797 82.7165 124.918 77.9436Z",
    fill: "url(#paint5_linear_512_1961)",
    stroke: "#1D074F",
    strokeWidth: 3.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7168 82.7822C77.8746 75.4559 72.874 68.5783 65.5478 67.4206C58.2215 66.2628 51.3439 71.2634 50.1861 78.5896C49.0284 85.9159 54.029 92.7935 61.3552 93.9513C68.6815 95.109 75.5591 90.1084 76.7168 82.7822Z",
    fill: "url(#paint6_linear_512_1961)",
    stroke: "#1D074F",
    strokeWidth: 3.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9914 86.6602C73.3119 83.0529 73.0795 77.4369 69.4722 74.1163C65.865 70.7958 60.2489 71.0282 56.9284 74.6355C53.6078 78.2427 53.8403 83.8588 57.4475 87.1793C61.0548 90.4999 66.6708 90.2674 69.9914 86.6602Z",
    fill: "url(#paint7_linear_512_1961)",
    stroke: "#1D074F",
    strokeWidth: 3.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7999 77.7608C95.7999 74.7106 94.1154 72.055 91.6343 70.6665C89.1532 72.0626 87.4688 74.7106 87.4688 77.7608C87.4688 80.811 89.1532 83.4667 91.6343 84.8552C94.1154 83.4591 95.7999 80.811 95.7999 77.7608Z",
    fill: "url(#paint8_linear_512_1961)",
    stroke: "#1D074F",
    strokeWidth: 3.03,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6727 60.3704C65.685 59.8696 68.0296 57.783 68.9932 55.1046C67.2101 52.8815 64.3192 51.6523 61.3146 52.1531C58.3023 52.6538 55.9578 54.7404 54.9941 57.4188C56.7772 59.642 59.6681 60.8712 62.6727 60.3704Z",
    fill: "url(#paint9_linear_512_1961)",
    stroke: "#1D074F",
    strokeWidth: 3.03,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1579 119.864C94.6162 118.066 95.7695 115.137 95.4281 112.314C92.8407 111.131 89.6995 111.343 87.2411 113.142C84.7828 114.94 83.6295 117.869 83.9709 120.691C86.5582 121.875 89.6995 121.662 92.1579 119.864Z",
    fill: "url(#paint10_linear_512_1961)",
    stroke: "#1D074F",
    strokeWidth: 3.03,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_512_1961",
    x: 0,
    y: 0,
    width: 144.18,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_512_1961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_512_1961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_512_1961",
    x1: 75.0404,
    y1: 25.8318,
    x2: 79.3046,
    y2: 87.8297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FDFE0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FDCC0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_512_1961",
    x1: 20.3196,
    y1: 24.3218,
    x2: 47.4451,
    y2: 54.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FDFE0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FDCC0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_512_1961",
    x1: 83.8577,
    y1: 31.3325,
    x2: 83.8577,
    y2: 58.1925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF63BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF5BC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF45C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FF22D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF0FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_512_1961",
    x1: 83.8373,
    y1: 35.8689,
    x2: 83.8373,
    y2: 53.6237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF63BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF5BC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF45C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FF22D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF0FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_512_1961",
    x1: 116.269,
    y1: 62.4449,
    x2: 116.269,
    y2: 89.3048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF63BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF5BC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF45C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FF22D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF0FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_512_1961",
    x1: 116.302,
    y1: 67.0257,
    x2: 116.302,
    y2: 84.7806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF63BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF5BC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF45C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FF22D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF0FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_512_1961",
    x1: 63.4663,
    y1: 67.2502,
    x2: 63.4663,
    y2: 94.1101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF63BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF5BC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF45C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FF22D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF0FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_512_1961",
    x1: 63.4367,
    y1: 71.7726,
    x2: 63.4367,
    y2: 89.5275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF63BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF5BC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF45C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FF22D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF0FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_512_1961",
    x1: 91.6343,
    y1: 70.6665,
    x2: 91.6343,
    y2: 84.8552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4AD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#46D500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3BCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#2AC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#11B100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_512_1961",
    x1: 61.9974,
    y1: 52.0392,
    x2: 61.9974,
    y2: 60.4766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4AD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#46D500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3BCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#2AC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#11B100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_512_1961",
    x1: 89.6995,
    y1: 111.578,
    x2: 89.6995,
    y2: 121.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4AD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#46D500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3BCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#2AC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#11B100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03A800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGroup2);
export default __webpack_public_path__ + "static/media/ic_group-2.04cae2d00eb685a7a0d0298016f0d54c.svg";
export { ForwardRef as ReactComponent };